



























import Vue from "vue";
import { state } from "./data/state";
// import Search from "@/components/Search.vue";
import NavbarTab from "./NavbarTab.vue";
export default Vue.extend({
  components: {
    //Search,
    NavbarTab,
  },
  setup() {
    const {
      trusted_entities_count,
      untrusted_entities_count,
      unmanaged_entities_count,
      //viewer_only_entities_count,
      query,
      current_tab,
      change_current_tab,
    } = state;

    return {
      query,
      trusted_entities_count,
      untrusted_entities_count,
      unmanaged_entities_count,
      //  viewer_only_entities_count,
      change_current_tab,
      current_tab,
    };
  },
});
